import React from 'react'
import styled from '~/app/components/styled'
import { Typography } from '@yanolja-rnd/ya-com-core'

const PendingReservationNoticeContainer = styled.div`
  margin-top: 1.6rem;
  padding: 1.6rem 1.4rem;
  border-radius: 0.4rem;
  border: solid 1px ${({ theme }) => theme.color.yaorange200};
  background-color: ${({ theme }) => theme.color.yaorange50};
  word-break: keep-all;
  color: ${({ theme }) => theme.color.gray900};
  ${Typography('body2.multiline').regular};
`

const PendingReservationNoticeTitle = styled.h4`
  font-weight: bold;
  margin-bottom: 0.8rem;
`

const PendingReservationNoticeTextWrapper = styled.div`
  display: grid;
  gap: 0.4rem;
`

const PendingReservationNotice = ({ className }: { className?: string }) => {
  return (
    <PendingReservationNoticeContainer className={className}>
      <PendingReservationNoticeTitle>
        {'해당 예약은 ‘확정 대기’ 상태예요.'}
      </PendingReservationNoticeTitle>
      <PendingReservationNoticeTextWrapper>
        <p>
          예약실 평일 09:00~18:00에 확정 여부를 확인해 순차 안내해 드려요. 이벤트나 성수기에는 확정
          안내가 더 늦어질 수 있어요.
        </p>
        <p>예약 확정 전 무료 취소 가능하며, 확정 불가 시 자동 취소 후 전액 환불해 드려요.</p>
      </PendingReservationNoticeTextWrapper>
    </PendingReservationNoticeContainer>
  )
}

export default PendingReservationNotice
